<template>
  <div>
    <transition name="fade">
      <div class="shareMenu" v-show="!this.isShowShareMenu && this.isShowMainMenuButton" @mouseup.prevent="openShareMenu">
        <img class="shareButton touch" src="../assets/images/menu/share.png"/>
      </div>
    </transition>

    <transition name="fade">
      <div id="shareMenuOpened" class="shareMenu" v-show="this.isShowShareMenu && this.isShowMainMenuButton" >
        <img class="shareSubButton touch" src="../assets/images/menu/close.png" @mouseup.prevent="closeShareMenu"/>
        <ShareNetwork
          network="facebook"
          :url="this.$t('homeURL')"
          title=""
        >
          <img class="shareSubButton touch" src="../assets/images/menu/facebook.png" @mouseup.prevent="shareFb"/>
        </ShareNetwork>
        <ShareNetwork
          network="whatsapp"
          :url="this.$t('homeURL')"
          title=""
        >
          <img class="shareSubButton touch" src="../assets/images/menu/whatsapp.png" @mouseup.prevent="shareWhatsapp"/>
        </ShareNetwork>
        <ShareNetwork
          network="twitter"
          :url="this.$t('homeURL')"
          title=""
        >
          <img class="shareSubButton touch" src="../assets/images/menu/twitter.png" @mouseup.prevent="shareTwitter"/>
        </ShareNetwork>
        <ShareNetwork
          network="line"
          :url="this.$t('homeURL')"
          title=""
        >
          <img class="shareSubButton touch" src="../assets/images/menu/line.png" @mouseup.prevent="shareLine"/>
        </ShareNetwork>
      </div>
    </transition>
  </div>
</template>

<script>

import i18n from '@/language';
import { store } from '../store'
import VueSocialSharing from '@/social' 

export default {
  name: 'shareMenu',
  components: {
    
  },
  data () {
    return {
      url : window.location.href,
      twitterURL : window.location.href.substring(0, window.location.href.length - 2),
      language : i18n.locale,
      isShowShareMenu : false,
      hashtags: 'Disney,Castle',
      isShowMainMenuButton : false,
    }
  },
  created(){
  },
  methods:{
    shareFb(){
      gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-8227103/15tha0/pi_hk009+standard'
      });
      gtag('event', 'Facebook Share',{
        'send_to': 'G-LPYZD9LDDW'
      });    
    },
    shareWhatsapp(){
      gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-8227103/15tha0/pi_hk009+standard'
      });
      gtag('event', 'Whatsapp Share',{
        'send_to': 'G-LPYZD9LDDW'
      });    
    },
    shareTwitter(){
      gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-8227103/15tha0/pi_hk009+standard'
      });
      gtag('event', 'Twitter Share',{
        'send_to': 'G-LPYZD9LDDW'
      });    
    },
    shareLine(){
      gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-8227103/15tha0/pi_hk009+standard'
      });
      gtag('event', 'Line Share',{
        'send_to': 'G-LPYZD9LDDW'
      });    
    },
    openShareMenu(){
      store.state.isShowShareMenu = true;
      gtag('event', 'Open Share Menu',{
        'send_to': 'G-LPYZD9LDDW'
      });
    },

    closeShareMenu(){
      store.state.isShowShareMenu = false;
      gtag('event', 'Close Share Menu',{
        'send_to': 'G-LPYZD9LDDW'
      });
    }
  },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},
    checkIsShowShareMenu(){return store.state.isShowShareMenu},
    checkIsShowMainMenuButton(){return store.state.isShowMainMenuButton},
  },
  watch:{
    checkCurrentLanguage(lang){this.language = lang;},
    checkIsShowShareMenu(isShowShareMenu){this.isShowShareMenu = isShowShareMenu},
    checkIsShowMainMenuButton(isShowMainMenuButton){this.isShowMainMenuButton = isShowMainMenuButton},

  },
}
</script>

<style scoped>
  .shareMenu{
    position: absolute;
    top: 20px;
    left: 10px;
    width: 36px;
    height: 36px;
  }

  .shareButton{
    width: 100%;
    margin-bottom: 10px;
  }
  .shareSubButton{
    width: 80%;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
    margin-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/shareMenu.vue